import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './ChatRoomList.css';

const ChatRoomList = ({ rooms, selectedRoom, onRoomSelect, onRefresh }) => {
  const { user } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');

  const filteredRooms = rooms.filter(room => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    return (
      room.name.toLowerCase().includes(query) ||
      room.peers.some(peer => peer.name.toLowerCase().includes(query))
    );
  });

  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m`;
    if (hours < 24) return `${hours}h`;
    if (days < 7) return `${days}d`;
    
    return date.toLocaleDateString();
  };

  const getRoomDisplayName = (room) => {
    if (room.name && !room.name.includes('&')) {
      return room.name;
    }
    // For peer-to-peer chats, show peer name
    if (room.peers && room.peers.length > 0) {
      return room.peers[0].name;
    }
    return room.name || 'Chat';
  };

  const getRoomAvatar = (room) => {
    if (room.peers && room.peers.length > 0) {
      return room.peers[0].profile_photo;
    }
    return null;
  };

  return (
    <div className="chat-room-list">
      <div className="chat-room-list-header">
        <h2>Chats</h2>
        <button className="refresh-btn" onClick={onRefresh} title="Refresh">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
          </svg>
        </button>
      </div>
      
      <div className="chat-room-search">
        <input
          type="text"
          placeholder="Search or start new chat"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="chat-room-items">
        {filteredRooms.length === 0 ? (
          <div className="chat-room-empty">
            <p>No chats found</p>
          </div>
        ) : (
          filteredRooms.map((room) => (
            <div
              key={room.id}
              className={`chat-room-item ${selectedRoom?.id === room.id ? 'active' : ''}`}
              onClick={() => onRoomSelect(room)}
            >
              <div className="chat-room-avatar">
                {getRoomAvatar(room) ? (
                  <img src={getRoomAvatar(room)} alt={getRoomDisplayName(room)} />
                ) : (
                  <div className="chat-room-avatar-placeholder">
                    {getRoomDisplayName(room).charAt(0).toUpperCase()}
                  </div>
                )}
                {room.unread_count > 0 && (
                  <span className="unread-badge">{room.unread_count}</span>
                )}
              </div>
              
              <div className="chat-room-content">
                <div className="chat-room-header">
                  <div className="chat-room-header-left">
                    <h3>{getRoomDisplayName(room)}</h3>
                    {room.peers && room.peers.length > 0 && room.peers[0].is_online && (
                      <span className="online-indicator-small"></span>
                    )}
                  </div>
                  {room.latest_message && (
                    <span className="chat-room-time">
                      {formatTime(room.latest_message.created_at)}
                    </span>
                  )}
                </div>
                
                {room.latest_message && (
                  <div className="chat-room-preview">
                    <span className="chat-room-message">
                      {room.latest_message.user_id === user?.id ? 'You: ' : ''}
                      {room.latest_message.message}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ChatRoomList;

